var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common_nav_inner" }, [
    _c(
      "div",
      { staticClass: "tabs" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.tabChange },
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          _vm._l(_vm.value.config.value, function (item, index) {
            return _c("el-tab-pane", {
              key: index,
              attrs: { label: item.name, name: index + "" },
            })
          }),
          1
        ),
      ],
      1
    ),
    ["entity", "new_entity"].includes(_vm.activeType) &&
    _vm.activeShowType === "2"
      ? _c(
          "div",
          { staticClass: "box2" },
          _vm._l(_vm.goodsList, function (item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              _c("div", {
                staticClass: "pic",
                style: { backgroundImage: "url(" + item.goods_thumb + ")" },
              }),
              _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "info" }, [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.goods_name)),
                  ]),
                  _c("div", { staticClass: "inventory" }, [
                    _vm._v(" 库存: 900 "),
                  ]),
                ]),
                _c("div", { staticClass: "price" }, [
                  _c("span", { staticClass: "num" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("moneyFormat")(item.shop_price)) + " "
                    ),
                  ]),
                  _vm._v(" 点 "),
                ]),
              ]),
            ])
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "box" },
          _vm._l(_vm.goodsList, function (item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              _c("div", {
                staticClass: "pic",
                style: { backgroundImage: "url(" + item.goods_thumb + ")" },
              }),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(item.goods_name)),
              ]),
              item.shop_price
                ? _c("div", { staticClass: "price" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("moneyFormat")(item.shop_price)) +
                          " "
                      ),
                    ]),
                    _vm._v(" 点 "),
                  ])
                : _vm._e(),
            ])
          }),
          0
        ),
    _vm.goodsList.length > 0
      ? _c("div", { staticClass: "more" }, [
          _vm._v(" 查看更多 "),
          _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }